import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'duotone-tools-svg-icon',
    templateUrl: 'duotone-tools-svg-icon.component.html',
    standalone: false
})

export class DuotoneToolsSvgIconComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
